import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'dialog-init-payslip',
  templateUrl: './dialogs-init-payslip.component.html',
  styleUrls: ['./dialogs-init-payslip.component.scss']
})
export class DialogsInitPayslipComponent {

  uploadingFile: boolean = false;
  uploadedFileData: any = null;

  constructor(
    public dialogRef: MatDialogRef<DialogsInitPayslipComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onFileUploaded(event: any): void {
    this.uploadedFileData = event;
  }

  onUploadingFileChange(isUploading: boolean): void {
    this.uploadingFile = isUploading;
  }

  onConfirm(): void {
    this.dialogRef.close(this.uploadedFileData);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
